import LaunchOutlinedIcon from '@mui/icons-material/LaunchOutlined';
import NavDivider from '@apps-common/ui-components/NavBar/NavDivider';
import ProductHome from '@apps-common/ui-components/NavBar/ProductHome';
import {AM_APP_URL, INSIGHTS_PLATFORM_URL} from '../constants.ts';
import {AppBar, AppBarProps, Box, Stack, Toolbar, Typography} from '@mui/material';
import {ManualLanguageMenu} from './ManualLanguageMenu.tsx';
import {ManualThemeSwitcher} from './ManualThemeSwitcher.tsx';
import {NavButton} from '@apps-common/ui-components/NavBar/NavMenuButton';
import {useTranslation} from 'react-i18next';

export const ManualHeader: React.FC<AppBarProps> = props => {
  const {t} = useTranslation();

  const goToAmApp = (): void => {
    if (!AM_APP_URL) {
      return;
    }
    window.open(AM_APP_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        zIndex: theme => theme.zIndex.drawer + 1,
        backgroundColor: 'background.paper',
        color: 'text.primary',
        borderBottom: 1,
        borderColor: 'divider',
      }}
      {...props}
    >
      <Toolbar variant="dense" disableGutters>
        <Box>
          <Stack
            direction="row"
            divider={<NavDivider />}
            sx={{
              gap: 1,
              alignItems: 'center',
              paddingX: 1,
            }}
          >
            {INSIGHTS_PLATFORM_URL && (
              <ProductHome href={INSIGHTS_PLATFORM_URL} title={t('insights-platform')} />
            )}
            <Typography
              variant="subtitle2"
              sx={{
                display: {
                  xs: 'none',
                  sm: 'inline',
                },
                paddingRight: 2,
              }}
            >
              Area Monitoring
            </Typography>
          </Stack>
        </Box>
        <NavDivider />
        <Stack
          direction="row"
          sx={{
            alignItems: 'center',
            gap: 1,
            paddingX: 1,
          }}
        >
          <Typography
            variant="subtitle2"
            sx={{
              display: {
                xs: 'none',
                sm: 'inline',
              },
            }}
          >
            {t('user-manual-label')}
          </Typography>
        </Stack>
        <Stack
          direction="row"
          sx={{
            paddingRight: 1,
            gap: 0.5,
            alignItems: 'center',
            marginLeft: 'auto',
          }}
        >
          <ManualThemeSwitcher />
          <ManualLanguageMenu />
          {AM_APP_URL && (
            <>
              <NavDivider />
              <NavButton title={t('open-am-app')} onClick={goToAmApp} aria-label={t('open-am-app')}>
                <LaunchOutlinedIcon />
              </NavButton>
            </>
          )}
        </Stack>
      </Toolbar>
    </AppBar>
  );
};
